import { render, staticRenderFns } from "./TaskQueue.vue?vue&type=template&id=712b0b92"
import script from "./TaskQueue.vue?vue&type=script&lang=js"
export * from "./TaskQueue.vue?vue&type=script&lang=js"
import style0 from "./TaskQueue.vue?vue&type=style&index=0&id=712b0b92&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports